module.exports = __webpack_public_path__ + "img/app-store.c672126e.svg";